export default __webpack_public_path__ + "static/media/SWINGBY-BNB.46051e6d.svg";